import request from '@/apis/request'
const resource = 'agent-info' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`,{ params })
  }, 
}